import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { POSITIONS } from '../../config/positions';
import { statsLeadersFiltersSelector } from 'store/modules/statspro/stats-leaders/selectors/filters-selector';
import { getTranslation } from 'common/react/utils/translations';
import { SelectMultiple } from 'common/react/components/select-multiple';
import { statsLeadersActions } from 'common/store/modules/statspro/stats-leaders';

export const StatsLeadersPosFilters = ({
    addOnResetCallback,
    maximumSelections,
    counterThreshold
}) => {
    const dispatch = useDispatch();

    const filters = useSelector(statsLeadersFiltersSelector);

    const updateFilterItem = (filterItem, value) => {
        dispatch(
            statsLeadersActions.setFilterItem({
                filterItem,
                value
            })
        );
    };

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <SelectMultiple
                // @ts-ignore
                items={POSITIONS}
                type="with-limit"
                icon="player-position"
                selections={POSITIONS.filter((p) =>
                    filters.positions.includes(p.name)
                )}
                label={getTranslation('label.statsLeaders.filters.position')}
                title={getTranslation('label.statsLeaders.filters.position')}
                itemToString={(pos) => pos.name}
                onSelectedItemsChange={(pos) => {
                    updateFilterItem(
                        'positions',
                        pos.map((p) => p.name)
                    );
                }}
                addOnResetCallback={addOnResetCallback}
                getItemText={(item) => item.name}
                getItemLabel={(item) => item.name}
                maximumSelections={maximumSelections}
                counterThreshold={counterThreshold}
                maximumSelectionsLabel={PULSE.I18N.lookup(
                    'label.filters.position.maxSelected',
                    { maximumSelections }
                )}
            />
        </div>
    );
};

StatsLeadersPosFilters.propTypes = {
    addOnResetCallback: PropTypes.func,
    maximumSelections: PropTypes.number,
    counterThreshold: PropTypes.number
};
